import styled from 'styled-components';

export const HeartBeatStatusWrapper = styled.div`
	width: auto;
	height: auto;
	min-width: 35px;
	min-height: 35px;
`;

export const Label = styled.label`
	font-style: normal;
	font-weight: normal;
	font-size: 12px;
	line-height: 16px;
	color: rgba(0, 0, 0, 0.54);
	margin-top: 0.5rem;
	margin-bottom: 0;
`;
